import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=5e32995d&scoped=true"
import script from "./Snapshot.vue?vue&type=script&lang=js"
export * from "./Snapshot.vue?vue&type=script&lang=js"
import style0 from "./Snapshot.vue?vue&type=style&index=0&id=5e32995d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32995d",
  null
  
)

export default component.exports